import { StyledProps } from '@front10';
import { Context } from '@front10/helpers/dist/Context';
import useStyles from '@front10/helpers/dist/UseStyles';
import dayjs from 'dayjs';
import React, { useContext } from 'react';
import {
  fullMonths,
  getRelativeDateLocalization,
  shortMonths,
} from '../../../../helpers/localization/localizationUtils';
import Box from '../../../elements/Box';
import { BoxProps } from '../../../elements/Box/Box';
import Text from '../../../elements/Text';
import { TextProps } from '../../../elements/Text/Text';

interface Props {
  dayStyles: TextProps;
  monthStyles: BoxProps & TextProps; // FIXME Conditional type
  yearStyles: BoxProps & TextProps; // FIXME Conditional type
  showDay: boolean;
  showMonth: boolean;
  showYear: boolean;
  showTwoLines: boolean;
  date: string;
  monthFormat: 'shortMonths' | 'fullMonths';
}

function FareItemDate(props: StyledProps<Props>) {
  const {
    date,
    showDay,
    showMonth,
    showYear,
    dayStyles,
    monthStyles,
    yearStyles,
    showTwoLines,
    monthFormat,
  } = props;
  const { direction, translate, localizationData, theme } = useContext(Context);
  const [className, style] = useStyles(props, { direction, theme });

  const { weekdays } = getRelativeDateLocalization(translate, localizationData);
  const months =
    monthFormat === 'shortMonths'
      ? shortMonths(translate, localizationData)
      : fullMonths(translate, localizationData);
  const month = (
    <Text marginLeft="1" {...monthStyles}>
      {months[Number(dayjs(date).format('M')) - 1]}
    </Text>
  );

  const year = (
    <Text marginLeft="1" {...yearStyles}>
      {dayjs(date).format('YYYY')}
    </Text>
  );

  return (
    <Box display="flex" className={className} style={style}>
      {showDay && dayStyles && (
        <Text {...dayStyles}>{weekdays[Number(dayjs(date).format('d'))]}</Text>
      )}
      {showMonth && (showTwoLines ? <Box {...monthStyles}>{month}</Box> : month)}
      {showYear && (showTwoLines ? <Box {...yearStyles}>{year}</Box> : year)}
    </Box>
  );
}

FareItemDate.defaultProps = {
  dayStyles: {},
  monthStyles: {},
  yearStyles: {},
  showDay: false,
  showMonth: true,
  showYear: true,
  date: '2019-08-15',
  showTwoLines: false,
  monthFormat: 'shortMonths',
};

FareItemDate.componentName = 'FareItemDate';

export default FareItemDate;
